export default __webpack_public_path__ + "static/media/Locandina-risottata.2bfd1c4e.jpg";